export const CUSTOMIS3D_PROD = process.env.VUE_APP_CUSTOMIS3D_PROD_URL;

export enum Urls {
  CUSTOMIS3D_VIDEO = 'https://www.youtube.com/embed/daARVOexnY0',
  CUSTOMIS3D_VIDEO_CHANNEL = 'https://www.youtube.com/@customis3d',
  CUSTOMIS3D_SHOPIFY_APP = 'https://apps.shopify.com/customis3d',
  CUSTOMIS3D_TWITTER = 'https://twitter.com/customis3dpod',
  CUSTOMIS3D_LINKEDIN = 'https://www.linkedin.com/company/customis3d-print-on-demand-solutions/about/'
}
